import React, { Component } from 'react';
import Tabs from './../../Global/Modules/Tabs'
import Text from './../../Global/Modules/Text'

class Toelatingseisen extends Component {


  render() {
    return (
      <div>
        <Text url={window.location.pathname} />
        <Tabs tab={1} url={window.location.pathname} />
      </div>
    );
  }
}

export default Toelatingseisen;



// WEBPACK FOOTER //
// ./src/components/Public/Pages/Toelatingseisen.js